export default __webpack_public_path__ + "static/media/heroBgSmall.5de987c3.jpg";